module.exports = __webpack_public_path__ + "static/media/google-play-btn@3.c3f1017d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/google-play-btn@3.png
// module id = 1563
// module chunks = 103